import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const faqs = [
  {
    question: "¿Qué aprenderá mi hijo en FinancieraMente?",
    answer: "Tu hijo aprenderá conceptos fundamentales de finanzas y emprendimiento a través de juegos y actividades interactivas. Esto incluye: manejo del dinero, ahorro e inversión, conceptos básicos de emprendimiento, toma de decisiones financieras y desarrollo de mentalidad emprendedora."
  },
  {
    question: "¿Cómo funciona la membresía?",
    answer: "Ofrecemos una membresía mensual con acceso ilimitado a todo el contenido. Comenzamos con una prueba gratuita de 7 días donde podrás explorar toda la plataforma. No hay compromiso de permanencia y puedes cancelar en cualquier momento."
  },
  {
    question: "¿Cómo puedo seguir el progreso de mi hijo?",
    answer: "Como padre o tutor, tú crearás y administrarás la cuenta. Desde la misma plataforma podrás ver directamente el progreso de tu hijo, sus logros y su evolución en el aprendizaje. Esto te permitirá acompañar activamente su desarrollo financiero y emprendedor."
  },
  {
    question: "¿Qué metodología de enseñanza utilizan?",
    answer: "Utilizamos una metodología práctica y divertida basada en el aprendizaje experiencial. Combinamos videos educativos, juegos interactivos, desafíos prácticos y proyectos reales que mantienen a los niños motivados mientras aprenden habilidades financieras esenciales."
  },
  {
    question: "¿Qué hace único a FinancieraMente?",
    answer: "FinancieraMente se destaca por su enfoque práctico y orientado a resultados. No solo enseñamos teoría financiera, sino que ayudamos a los niños a desarrollar una mentalidad emprendedora y habilidades prácticas que podrán aplicar en la vida real. Además, nuestro contenido está adaptado al contexto latinoamericano."
  },
  {
    question: "¿Cuánto tiempo necesita dedicar mi hijo?",
    answer: "El programa está diseñado para ser flexible. Recomendamos sesiones de 30-45 minutos, 2-3 veces por semana. El contenido está estructurado en módulos que se pueden completar al ritmo de cada niño, adaptándose perfectamente a su rutina escolar y actividades extracurriculares."
  }
];

export const FAQ = () => {
  return (
    <section className="py-16 bg-white">
      <div className="container mx-auto px-4 max-w-4xl">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-12 text-primary">
          Preguntas Frecuentes
        </h2>
        <Accordion type="single" collapsible className="w-full">
          {faqs.map((faq, index) => (
            <AccordionItem key={index} value={`item-${index}`}>
              <AccordionTrigger className="text-lg font-semibold text-left">
                {faq.question}
              </AccordionTrigger>
              <AccordionContent className="text-gray-600">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};